// Layout for the notification preferences surface (bead hf-e7-notifications-742.3).
//
// THE ONE LAYOUT DECISION THAT IS A PRODUCT DECISION: an always-on category looks
// exactly like a switchable one, apart from having a sentence where the switch would
// be. No greyed-out control, no lock icon, no disabled toggle. A disabled switch is a
// picture of something being withheld; a sentence explaining what the message is and
// offering the channel choice is the same fact told as information.
export const notificationStylesheet = `
.notification-preferences { display: grid; gap: var(--space-24, 1.5rem); }
.notification-preferences h2 { margin: 0; }
.notification-preferences__introduction { margin: 0; color: var(--color-ink-muted, #5b6862); }
.notification-preferences__list { display: grid; gap: var(--space-16, 1rem);
  list-style: none; margin: 0; padding: 0; }

.notification-category { display: grid; gap: var(--space-8, 0.5rem); }
.notification-category__title { margin: 0; font-weight: 600; }
.notification-category__body { margin: 0; color: var(--color-ink-muted, #5b6862); }
/* The sentence that stands where a switch would be. Same weight as the surrounding
   text: it is information, not a warning. */
.notification-category__always-on { margin: 0; color: var(--color-ink-muted, #5b6862); }
.notification-category__channels { display: flex; flex-wrap: wrap;
  gap: var(--space-16, 1rem); margin: 0; padding: 0; border: 0; }
.notification-category__channels legend { padding: 0; font-size: var(--font-size-14, 0.875rem);
  color: var(--color-ink-muted, #5b6862); }
.notification-category__choice { display: flex; align-items: center;
  gap: var(--space-8, 0.5rem); min-height: var(--target-size-44, 2.75rem); }

.notification-quiet-hours { display: grid; gap: var(--space-8, 0.5rem); }
.notification-quiet-hours__fields { display: flex; flex-wrap: wrap;
  gap: var(--space-16, 1rem); align-items: flex-end; }
.notification-quiet-hours__policy { margin: 0; border-radius: var(--radius-8, 0.5rem);
  border: 1px solid var(--color-border, #d7ded9); padding: var(--space-12, 0.75rem);
  background: var(--color-surface-sunken, #f4f7f5); }
.notification-preferences__actions { display: flex; flex-wrap: wrap;
  gap: var(--space-8, 0.5rem); align-items: center; }
`;
